import styled from 'styled-components'

export const Container = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
}))

export const D2DSection = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
  marginTop: theme.space['24'],
}))
